import React, { useEffect } from 'react';
import { GraduationCap, Rocket, Briefcase } from 'lucide-react';
import { useConventionsStore } from '../../stores/conventionsStore';

const TRACKED_STATUTS: { label: string; match: string[]; icon: React.ReactNode }[] = [
  { label: 'Formations courtes en attente', match: ['Formations courtes en attentes', 'Formations courtes en attente'], icon: <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-sky-200 shrink-0" /> },
  { label: 'Formations courtes en cours', match: ['Formations courtes en cours'], icon: <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-sky-200 shrink-0" /> },
  { label: 'Formations courtes en attente de validation', match: ['Formations courtes en attente de validation'], icon: <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-sky-200 shrink-0" /> },
  { label: 'Formations longues en cours', match: ['Formations longues en cours'], icon: <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-indigo-200 shrink-0" /> },
  { label: 'Formations longues réalisées', match: ['Formations longues réalisées', 'Formations longues réalisée'], icon: <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-indigo-200 shrink-0" /> },
  { label: 'Formations longues en attente', match: ['Formations longues en attente'], icon: <GraduationCap className="w-4 h-4 md:w-5 md:h-5 text-indigo-200 shrink-0" /> },
  { label: 'Création entreprise en projet', match: ['Création entreprise en projet'], icon: <Rocket className="w-4 h-4 md:w-5 md:h-5 text-cyan-200 shrink-0" /> },
  { label: 'Création entreprise réalisée', match: ['Création entreprise réalisée', 'Création entreprises réalisées'], icon: <Rocket className="w-4 h-4 md:w-5 md:h-5 text-teal-200 shrink-0" /> },
];

export function ReclassementStatsPanel() {
  const { conventions, employees, loadConventions, loadAllEmployees } = useConventionsStore();

  useEffect(() => {
    if (conventions.length === 0) {
      loadConventions();
    }
  }, [conventions.length, loadConventions]);

  useEffect(() => {
    if (conventions.length > 0 && employees.length === 0) {
      loadAllEmployees();
    }
  }, [conventions.length, employees.length, loadAllEmployees]);

  const counts = TRACKED_STATUTS.map(s => ({
    ...s,
    count: employees.filter(e => s.match.includes(e.statut)).length,
  }));

  return (
    <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-2 w-full">
      {counts.map(s => (
        <div
          key={s.label}
          title={s.label}
          className="bg-white/10 backdrop-blur-sm rounded-lg p-2 md:p-3 border border-white/20 flex items-center gap-1.5 md:gap-2"
        >
          {s.icon}
          <div className="min-w-0 flex-1">
            <div className="text-sm md:text-lg font-bold text-white leading-tight">{s.count}</div>
            <div className="text-[10px] md:text-xs text-white/80 leading-tight line-clamp-3">{s.label}</div>
          </div>
        </div>
      ))}
    </div>
  );
}
